<mat-toolbar class="header bg-transparent p-3">
  @if (baseService.isMobile) {
    <button
      mat-icon-button
      class="menu-btn"
      aria-label="Example icon-button with menu icon"
      (click)="sidebarService.toggle()"
    >
      <app-icon>menu</app-icon>
    </button>
  }

  <div
    (click)="baseService.toHome()"
    class="click-css flex gap-[10px]">
    <img
      class="logo"
      src="/assets/svgs/logos/logo.svg"
      alt="logo"
    />
    <span class="title">{{ baseService.company.name }}</span>
  </div>

  <span class="flex-fill"></span>

  @if (!audioService.audioSource.length && !baseService.isMobile) {
    <div
      class="time-box"
      (click)="getRandomQuote()"
      matTooltip="{{ currentQuote.text }}  {{ currentQuote.author }}"
      matTooltipPosition="below"
    >
      {{ rxDate | date: 'HH:mm:ss' }}
      <span class="quote">{{ currentQuote.text }}</span>
    </div>
  }

  @if (audioService.audioSource.length && !baseService.isMobile) {
    <div>
      <app-audio-player></app-audio-player>
    </div>
  }

  <span class="flex-fill"></span>

  @if (!baseService.isMobile) {
    @if (baseService.currentCompanyInfo?.tariff === 'free' || baseService.currentCompanyInfo?.tariff === 'trial') {
      <div>
        @if (baseService.currentCompanyInfo?.tariff !== 'free' && baseService.currentCompanyInfo.tariff_updated_at) {
          <div
            [matMenuTriggerFor]="trialDays > 0 ? tarifMenu : null"
            [ngClass]="{ bgTrial: trialDays <= 2 }"
            #menuTrigger="matMenuTrigger"
            class="d-flex align-items-center justify-content-around click-css"
            style="background-color: #ea5728; height: 36px; border-radius: 4px; width: 250px"
          >
            <app-icon style="padding: 0 0 0 2px">rocket</app-icon>
            @if (baseService.currentCompanyInfo?.tariff === 'trial' && !(trialDays <= 2)) {
              <span>{{ 'your_tariff' | translate }}: Demo</span>
            }
            @if (baseService.currentCompanyInfo?.tariff === 'trial' && trialDays <= 2) {
              <span>{{ 'your_tariff' | translate }}: Demo</span>
            }
            @if (menuTrigger.menuOpen && trialDays > 0) {
              <app-icon>keyboard_arrow_up </app-icon>
            }
            @if (!menuTrigger.menuOpen && trialDays > 0) {
              <app-icon>keyboard_arrow_down </app-icon>
            }
          </div>
        }
        @if (baseService.currentCompanyInfo?.tariff === 'free' && !baseService.currentCompanyInfo.tariff_updated_at) {
          <div
            (click)="startDemo($event)"
            class="d-flex align-items-center justify-content-around click-css"
            style="
              background-color: var(--primary-color) !important;
              height: 36px;
              border-radius: 4px;
              padding: 0 8px 0 8px;
            "
          >
            <app-icon style="padding: 0 0 0 2px">rocket</app-icon>
            <span class="px-2">{{ 'try_demo' | translate }}</span>
          </div>
        }
        @if (baseService.currentCompanyInfo?.tariff === 'free' && baseService.currentCompanyInfo.tariff_updated_at) {
          <div
            (click)="goToPayment()"
            class="d-flex align-items-center justify-content-around click-css"
            style="background-color: rgba(72, 60, 228, 0.95) !important; height: 36px; border-radius: 4px; width: 200px"
          >
            <app-icon style="padding: 0 0 0 2px">rocket</app-icon>
            <span>{{ 'buy_tariff' | translate }}</span>
          </div>
        }
      </div>
    }
  }

  <mat-menu #tarifMenu class="text-dark profile-menu" yPosition="below" xPosition="before">
    @if (trialDays > 0) {
      <div class="d-flex align-items-center px-3 py-2 gap-2 overflow-hidden">
        <span class="text-dark">До кінця демо режиму залишилось {{ trialDays }} дня(-ів)</span>
      </div>
    }
    @if (trialDays <= 0) {
      <div class="d-flex align-items-center px-3 py-2 gap-2 overflow-hidden">
        <span class="text-dark">Це останній день демо режиму</span>
      </div>
    }
  </mat-menu>

  @if (baseService.currentUserInfo) {
    <div class="overflow-hidden">
      <div class="profile-header-box" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
        <app-avatar size="40px" [title]="getUserName" [url]="getAvatarUrl" [isPhotoGallery]="false" />
        <span class="profile-name">{{ baseService.currentUserInfo.first_name }}</span>
        @if (menuTrigger.menuOpen) {
          <app-icon>keyboard_arrow_up</app-icon>
        }
        @if (!menuTrigger.menuOpen) {
          <app-icon>keyboard_arrow_down</app-icon>
        }
      </div>
      <mat-menu #menu class="text-dark profile-menu" yPosition="below" xPosition="before">
        <div class="d-flex align-items-center px-3 py-2 gap-2 overflow-hidden">
          <app-avatar size="40px" [title]="getUserName" [url]="getAvatarUrl" [isPhotoGallery]="false" />
          <div class="name-prof">
            <span>
              {{ baseService.currentUserInfo.first_name }}
              {{ baseService.currentUserInfo.last_name }}
            </span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="profile()">
          <div class="d-flex">
            <app-icon>person</app-icon>
            {{ 'profile' | translate }}
          </div>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="baseService.toPreview()">
          <div class="d-flex">
            <app-icon>home</app-icon>
            {{ 'home' | translate }}
          </div>
        </button>
        <button mat-menu-item (click)="themes()">
          <div class="d-flex">
            <app-icon>palette</app-icon>
            {{ 'topics' | translate }}
          </div>
        </button>
        <button mat-menu-item (click)="companies()">
          <div class="d-flex">
            <app-icon>apartment</app-icon>
            {{ 'companies' | translate }}
          </div>
        </button>
        <div mat-menu-item (click)="$event.stopPropagation()" class="menu-dropdown">
          <div class="flex items-center">
            <app-icon>language</app-icon>
            <app-select
              labelType="float"
              optionLabel="name"
              optionValue="value"
              [options]="fullLanguages"
              (valueChange)="switchLanguage()"
              [formControl]="settingsForm.controls.language"
            />
          </div>
        </div>
        @if (isHasSettingsPer) {
          <button mat-menu-item (click)="settings()">
            <div class="d-flex">
              <app-icon>settings</app-icon>
              {{ 'settings' | translate }}
            </div>
          </button>
        }
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <div class="d-flex">
            <app-icon>logout</app-icon>
            {{ 'exit' | translate }}
          </div>
        </button>
      </mat-menu>
    </div>
  }

  <mat-menu #company_menu class="bg-dark company-menu p-2">
    <div (click)="$event.stopPropagation()">
      @if (companyForm) {
        <p [formGroup]="companyForm" class="text-center">
          {{ 'here_you_can_enter/change_your_company_name' | translate }}.
        </p>
      }
      <app-text-field
        label="{{ 'company_name' | translate }}:"
        [formControl]="companyForm.controls.name"
      ></app-text-field>
      @if (isEditSubdomain()) {
        <div>
          <app-text-field
            label="{{ 'your_subdomain' | translate }}:"
            [maxLength]="10"
            [formControl]="companyForm.controls.subdomain"
            [error]="formSubmitted && companyForm.controls.subdomain.status === 'INVALID'"
          ></app-text-field>
          @if (formSubmitted && companyForm.controls.subdomain.status === 'INVALID') {
            <div class="d-flex align-items-center">
              <span style="color: #ff381a; font-size: 12px">
                {{
                  'the_selected_subdomain_may_already_be_taken._Please_select_another_subdomain_up_to_10_characters_using_only_lowercase-Latin_letters_and_a_hyphen._The_hyphen_cannot_be_the_last_character_of_the_subdomain'
                    | translate
                }}.
              </span>
            </div>
          }
          <div class="d-flex align-items-center">
            <span style="font-size: 12px">
              {{ "you_can_change_the_company's_subdomain_only_for_the_first_3_days" | translate }}.
            </span>
          </div>
        </div>
      }

      <div class="my-2">
        {{ 'your_address' | translate }}: {{ companyForm.controls.subdomain.value }}.{{ environment.web_url }}
      </div>

      @if (warn) {
        <div class="warn-msg">
          <app-icon class="float-start mx-2" style="color: #ff381a">warning </app-icon>
          <span class="warn-msg-txt">
            {{
              'the_selected_subdomain_may_already_be_taken._Please_select_another_subdomain_up_to_10_characters_using_only_lowercase-Latin_letters_and_a_hyphen._The_hyphen_cannot_be_the_last_character_of_the_subdomain'
                | translate
            }}.
          </span>
        </div>
      }
      <div class="d-flex justify-content-end">
        @if (isEditSubdomain()) {
          <app-button (onChangeClick)="submit()">{{ 'save' | translate }} </app-button>
        }
        @if (!isEditSubdomain()) {
          <app-button (onChangeClick)="submitCompany()">{{ 'save' | translate }} </app-button>
        }
      </div>
    </div>
  </mat-menu>

  <div>
    <app-button
      btnType="icon"
      onclick="this.blur()"
      (click)="initNotification()"
      [matMenuTriggerFor]="notification_menu"
    >
      <app-icon
        [badgeHidden]="!notificationService.notificationsCount"
        [badge]="notificationService.notificationsCount > 99 ? '99+' : String(notificationService.notificationsCount)"
      >
        notifications
      </app-icon>
    </app-button>
  </div>

  <div>
    @if (isHasChatPer) {
      <button mat-icon-button onclick="this.blur()" (click)="openChat()">
        <app-icon
          [badgeHidden]="!chatService.message_count"
          [badge]="chatService.message_count > 99 ? '99+' : String(chatService.message_count)"
        >
          chat
        </app-icon>
      </button>
    }
  </div>
</mat-toolbar>

@if (this.baseService.company.is_paused) {
  <div class="tariff-expired">
    <span class="tariff-expired-span">{{ 'tariff_expired' | translate }}</span>
  </div>
}

<!-- МЕНЮ -->
<mat-menu #notification_menu="matMenu" xPosition="before" yPosition="below" class="notif-menu-panel">
  <app-notification-menu />
</mat-menu>
